import React, {useEffect, useState} from 'react';
import Wrapper from "../components/Wrapper.js";
import {useLocation, useNavigate} from "react-router-dom";
import qs from "query-string";
import {useDispatch, useSelector} from "react-redux";
import Api from "../Api.js";
import {surveyAddLocalRequest} from "../store/actions/dayoff.js";
import {accountantRequest, taskCompanyRequest, taskManagerRequest} from "../store/actions/task.js";
import {word} from "../word.js";
import Button from "../components/Button/Button.js";
import DatePicker from "react-datepicker";
import Loader from "../components/BlueButton/Loader.js";
import {Col, Row} from "react-bootstrap";
import CustomPagination from "../components/BlueButton/CustomPagination.js";
import AddAndEditSurvey from "../components/Survey/AddAndEditSurvey.js";
import SurveyItem from "../components/Survey/SurveyItem.js";
import Select from "react-select";

function Surveys(props) {
    const [status] = useState([
        {key: "draft", label: "Դիտարկում"},
        {key: "active", label: "Սկսված"},
        {key: "ended", label: "Ավարտված"},
        {key: "all", label: "Բոլորը"}
    ]);
    const navigate = useNavigate()
    const location = useLocation()
    const company = useSelector((state) => state.task.companies);

    const query = qs.parse(location.search, {arrayFormat: 'comma'});
    const [loading, setLoading] = useState(null)
    const survey = useSelector((state) => state.dayoff.survey);
    const dispatch = useDispatch()
    const [show, setShow] = useState(false)
    const [activeId, setActiveId] = useState('all')

    useEffect(() => {
        (async () => {
            await dispatch(taskCompanyRequest())
        })();
    }, []);
    useEffect(() => {
        (async () => {
            try {
                setLoading(true)
                let querystring = qs.stringify(query, {
                    arrayFormat: 'comma',
                    skipEmptyString: true,
                })

                setActiveId(query.status ? query.status : "")
                const {data} = await Api.getSurvey(querystring)
                dispatch(surveyAddLocalRequest(data))
                setLoading(false)
            } catch (e) {

            }
        })()
    }, [location.search])

    const handleFilter = (name, value) => {
        query[name] = value;
        let querystring = qs.stringify(query, {
            arrayFormat: 'comma',
            skipEmptyString: true,
        })
        navigate(`?${querystring}`, {replace: true});
    }
    const handlePageChange = async (pageNumber) => {
        query.offset = pageNumber === 1 ? '' : (pageNumber - 1) * 10;
        query.page = pageNumber;
        let querystring = qs.stringify(query, {
            arrayFormat: 'comma',
            skipEmptyString: true,
        })
        navigate(`?${querystring}`, {replace: true});
    };
    const selectedCompanyIds = (
        Array.isArray(query.company)
            ? query.company
            : typeof query.company === "string"
            ? query.company.split(",")
            : []
    ).map(Number);
    return (
        <Wrapper>

            <div className='users'>

                <div className='plus-cont' onClick={() => setShow(true)}>
                    <span className="plus">+</span>
                    <span className="tooltiptext">{word.addItem}</span>
                </div>

                <div className="tasks-buttons">
                    {status.map((l, i) => (
                        <Button
                            key={i}
                            buttonStyle={
                                activeId !== l.key && (activeId !== "all" || activeId !== "") ? "middle-button task-button" : "task-button-active"
                            }
                            title={l.label}
                            onChangeValue={async () => {
                                await handleFilter('status', l.key === "all" ? "" : l.key);
                                setActiveId(l.key === "Բոլորը" ? "" : l.key);
                            }}
                        />
                    ))}
                </div>
                <div className="tasks-data tasks-data-manager">
                    <span className='tasks-data-item'>
                    <DatePicker
                        dateFormat="dd/MM/yyyy"
                        selected={query.start_date_after || new Date().toISOString().split('T')[0]}
                        showMonthYearDropdown
                        onChange={(date) => handleFilter('start_date_after', date.toISOString().split('T')[0])}
                    />
                    </span>
                    <span className='tasks-data-item'>
                    <DatePicker
                        dateFormat="dd/MM/yyyy"
                        selected={query.start_date_before || new Date().toISOString().split('T')[0]}
                        showMonthYearDropdown
                        onChange={(date) => handleFilter('start_date_before', date.toISOString().split('T')[0])}
                    />
                    </span>
                    <div style={{width: 300}}>
                        <Select

                            className="basic-single"
                            classNamePrefix="select"
                            isMulti
                            options={company.map((l) => ({value: l.id, label: l.name}))}
                            value={company.filter(c => selectedCompanyIds.includes(c.id)).map(c => ({
                                value: c.id,
                                label: c.name
                            }))}
                            onChange={(value) => handleFilter('company', value.map(v => v.value))}
                        />
                    </div>


                </div>
                <div className="tasks-cont">
                    {loading ? <div className="loader-margin-small">
                        <Loader size={20}/>
                    </div> : survey?.results?.length ?
                        <Row className=" flex-row" style={{marginTop: 20}}>
                            {query?.id ? <Col md={6}>
                                <SurveyItem item={survey.results.find(l => +l.id === +query?.id)}/>
                            </Col> : survey.results.map((l, ind) => (
                                    <Col md={6} key={ind}>
                                        <SurveyItem item={l}/>
                                    </Col>
                                )
                            )}
                        </Row>
                        :
                        <div className="no_tasks text-center">{word.no_survey}</div>}
                    {survey?.count > 10 && (
                        <div className="d-flex justify-content-center">
                            <CustomPagination
                                currentPage={+query.page || 1}
                                totalItems={survey?.count || 0}
                                itemsPerPage={10}
                                totalPages={survey?.count ? Math.ceil(survey?.count / 10) : 0}
                                onPageChange={(newPage) => handlePageChange(newPage)}
                            />
                        </div>
                    )}
                </div>


            </div>

            {show ? <AddAndEditSurvey show={show} onHide={() => setShow(false)}/> : null}

        </Wrapper>
    );

}

export default Surveys;